import { Component } from '@angular/core';

@Component({
    selector: 'lib-auth',
    template: `
    <p>
      auth works!
    </p>
  `,
    styles: ``,
    standalone: false
})
export class AuthComponent {

}
